import { render, staticRenderFns } from "./distribuidor.vue?vue&type=template&id=1ebeafa0&scoped=true"
import script from "./distribuidor.vue?vue&type=script&lang=js"
export * from "./distribuidor.vue?vue&type=script&lang=js"
import style0 from "./distribuidor.vue?vue&type=style&index=0&id=1ebeafa0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ebeafa0",
  null
  
)

export default component.exports